export class IPersistentFilter {
  scdGid?: string;
  accountingMonth?: string;
  lastRunDate?: string;
  timesheetDisplayMode?: number;
  showProjectnumberInTS?: boolean;
  timesheetFilterSettings?: string;
  accountsFilterSettings?: string;
  projectsFilterSettings?: string;
  controllingFilter?: string;
  filterPartner?: string;
  filterGroup?: string;
  filterTeam?: string;
}

export interface ITimesheetFilterSettings {
  pageSize: number;
}
